import { useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(2.5, 3),
    borderRadius: 16,
    textAlign: 'left',
    minHeight: 90,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
    borderLeft: '3px solid transparent',
  },
  number: {
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1.1,
  },
  label: {
    fontSize: '0.75rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
}));

export const StatCardsRow = () => {
  const classes = useStyles();
  const catalogApi = useApi(catalogApiRef);
  const [stats, setStats] = useState<{ services: number; templates: number; apis: number; groups: number } | null>(null);

  useEffect(() => {
    Promise.all([
      catalogApi.getEntities({ filter: { kind: 'Component' }, fields: ['metadata.name'] }),
      catalogApi.getEntities({ filter: { kind: 'Template' }, fields: ['metadata.name'] }),
      catalogApi.getEntities({ filter: { kind: 'API' }, fields: ['metadata.name'] }),
      catalogApi.getEntities({ filter: { kind: 'Group' }, fields: ['metadata.name'] }),
    ]).then(([components, templates, apis, groups]) => {
      setStats({
        services: components.items.length,
        templates: templates.items.length,
        apis: apis.items.length,
        groups: groups.items.length,
      });
    }).catch(() => {
      setStats({ services: 0, templates: 0, apis: 0, groups: 0 });
    });
  }, [catalogApi]);

  const items = [
    { value: stats?.services, label: 'Services', accent: '#187E3F' },
    { value: stats?.templates, label: 'Templates', accent: '#29707A' },
    { value: stats?.apis, label: 'APIs', accent: '#FF462D' },
    { value: stats?.groups, label: 'Teams', accent: '#7C3AED' },
  ];

  return (
    <Grid container spacing={3}>
      {items.map(item => (
        <Grid item xs={6} md={3} key={item.label}>
          <Card
            className={classes.card}
            elevation={0}
            style={{ borderLeftColor: item.accent }}
          >
            {stats === null ? (
              <Skeleton variant="rect" height={40} width={50} style={{ borderRadius: 8 }} />
            ) : (
              <div>
                <Typography className={classes.number} style={{ color: item.accent }}>
                  {item.value}
                </Typography>
                <Typography className={classes.label}>{item.label}</Typography>
              </div>
            )}
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
